import React from "react";
import "./styles.css";

const EkycVerification = ({
  title = "Verification successful",
  description = [
    "The identity has been successfully verified.",
    "You can now continue with your order."
  ],
  actionButtonText,
  onAction,
  children
}) => {
  return (
    <div className="verification-success-container">
      {/* Success Checkmark Icon */}
      <div className="verification-success-icon">
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="28" cy="28" r="28" fill="#BBE2FF" />
          <path
            d="M17.5 28.5L24.5 35.5L38.5 21.5"
            stroke="#0088FF"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Header */}
      <h2 className="verification-success-title">{title}</h2>

      {/* Description */}
      <div className="verification-success-description">
        {Array.isArray(description) ? (
          description.map((line, idx) => <p key={idx}>{line}</p>)
        ) : typeof description === "string" ? (
          description.split("\n").map((line, idx) => <p key={idx}>{line}</p>)
        ) : (
          description
        )}
      </div>

      {/* Optional Children */}
      {children && <div className="verification-success-children">{children}</div>}

      {/* Optional Action Button */}
      {actionButtonText && onAction && (
        <button className="verification-success-button" onClick={onAction}>
          {actionButtonText}
        </button>
      )}
    </div>
  );
};

export default EkycVerification;